var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sfdr-tooltip" }, [
    _c("div", {
      staticClass: "tooltip-arrow-header",
      class: {
        "arrow-left": _vm.orientation.x === "right",
        "arrow-right": _vm.orientation.x === "left",
        "arrow-top": _vm.orientation.y === "bottom",
        "arrow-bottom": _vm.orientation.y === "top"
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "tooltip-header" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tooltip-content" },
      _vm._l(_vm.config, function(item) {
        return _c(
          "div",
          { key: item.title, staticClass: "tooltip-item" },
          [
            _c("div", { staticClass: "tooltip-title" }, [
              _vm._v("\n        " + _vm._s(item.title) + "\n      ")
            ]),
            _vm._v(" "),
            item.component
              ? _c(
                  item.component,
                  _vm._b(
                    { tag: "component", staticClass: "tooltip-value" },
                    "component",
                    item.props,
                    false
                  )
                )
              : _c(
                  "div",
                  {
                    staticClass: "tooltip-value",
                    style: { color: item.colorValue }
                  },
                  [_vm._v("\n        " + _vm._s(item.value) + "\n      ")]
                )
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tooltip-arrow" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }